import { jsx, jsxs } from "react/jsx-runtime";
const InstagramIcon = ({ fill }) => {
  return /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: "100%", viewBox: "0 0 36 36", children: /* @__PURE__ */ jsxs("g", { id: "Group_3112", "data-name": "Group 3112", transform: "translate(-1358 -11590)", children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_13661",
        "data-name": "Path 13661",
        d: "M18 0a18 18 0 1 0 18 18A18 18 0 0 0 18 0z",
        transform: "translate(1358 11590)",
        style: { fill: fill || "#181d56" }
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_13662",
        "data-name": "Path 13662",
        d: "M318.176 162.587a1.348 1.348 0 1 0-1.348-1.348 1.349 1.349 0 0 0 1.348 1.348z",
        transform: "translate(1063.305 11441.278)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_13663",
        "data-name": "Path 13663",
        style: { fill: "#fff" },
        d: "M186.281 192.054a5.769 5.769 0 1 0-5.769-5.769 5.769 5.769 0 0 0 5.769 5.769zm0-9.514a3.745 3.745 0 1 1-3.745 3.745 3.745 3.745 0 0 1 3.745-3.745z",
        transform: "translate(1189.719 11421.715)"
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        id: "Path_13664",
        "data-name": "Path 13664",
        style: { fill: "#fff" },
        d: "M109.508 125a4.944 4.944 0 0 0 2.828 2.828 7.1 7.1 0 0 0 2.347.449c1.031.047 1.361.058 3.987.058s2.955-.011 3.987-.058a7.1 7.1 0 0 0 2.347-.449 4.944 4.944 0 0 0 2.827-2.828 7.094 7.094 0 0 0 .449-2.347c.047-1.031.058-1.361.058-3.987s-.011-2.955-.058-3.987a7.093 7.093 0 0 0-.45-2.347 4.946 4.946 0 0 0-2.83-2.825 7.1 7.1 0 0 0-2.347-.449c-1.031-.047-1.361-.059-3.987-.059s-2.955.011-3.987.058a7.1 7.1 0 0 0-2.347.449 4.948 4.948 0 0 0-2.828 2.828 7.1 7.1 0 0 0-.449 2.347c-.047 1.031-.058 1.361-.058 3.987s.011 2.955.059 3.987a7.093 7.093 0 0 0 .452 2.345zm1.291-10.241a5.353 5.353 0 0 1 .333-1.8 3.2 3.2 0 0 1 1.835-1.835 5.355 5.355 0 0 1 1.8-.333c1.02-.047 1.325-.056 3.907-.056s2.888.01 3.907.057a5.351 5.351 0 0 1 1.8.333 3.2 3.2 0 0 1 1.835 1.835 5.344 5.344 0 0 1 .333 1.8c.047 1.02.056 1.325.056 3.907s-.01 2.888-.056 3.907a5.355 5.355 0 0 1-.333 1.8 3.2 3.2 0 0 1-1.835 1.835 5.344 5.344 0 0 1-1.8.333c-1.019.046-1.325.056-3.907.056s-2.888-.01-3.907-.056a5.344 5.344 0 0 1-1.8-.333 3.2 3.2 0 0 1-1.835-1.835 5.351 5.351 0 0 1-.333-1.8c-.047-1.02-.057-1.326-.057-3.907s.01-2.885.058-3.905z",
        transform: "translate(1257.33 11489.33)"
      }
    )
  ] }) });
};
export {
  InstagramIcon
};
//# sourceMappingURL=footer_instergram.js.map
